import React, { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur, réessayez plus tard");
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="flex justify-center mb-8"><Logo size={56} /></div>
        <div className="bg-white rounded-3xl border border-rose-100 p-8 shadow-sm">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-sent">
              <CheckCircle size={56} weight="duotone" className="mx-auto text-emerald-500" />
              <h1 className="font-display text-2xl font-black text-stone-800 mt-3">Vérifiez vos emails</h1>
              <p className="text-stone-600 mt-3">
                Si un compte existe pour <strong>{email}</strong>, un lien de réinitialisation vient de vous être envoyé. Il est valable <strong>1 heure</strong>.
              </p>
              <p className="text-sm text-stone-500 mt-3">Pensez à vérifier votre dossier <strong>Spam / Courrier indésirable</strong>.</p>
              <Link to="/connexion" className="inline-block mt-6" data-testid="forgot-password-back-login">
                <Button className="bg-orange-500 hover:bg-orange-600 rounded-full font-bold px-6">Retour à la connexion</Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-black text-stone-800 text-center">Mot de passe oublié</h1>
              <p className="text-stone-600 text-center mt-2 text-sm">Entrez votre email — nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>
              <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="parent@famille.fr" className="rounded-2xl mt-1 py-6" data-testid="forgot-password-email-input" />
                </div>
                <Button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 rounded-full py-6 font-bold shadow-lg shadow-orange-500/30" data-testid="forgot-password-submit">
                  <EnvelopeSimple size={18} weight="bold" className="mr-2" />
                  {loading ? "Envoi en cours..." : "Envoyer le lien"}
                </Button>
              </form>
              <p className="text-center text-sm text-stone-500 mt-6">
                Vous vous en souvenez ? <Link to="/connexion" className="text-orange-600 font-bold" data-testid="forgot-password-login-link">Se connecter</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}
